import React, { useState } from 'react';
import API_BASE_URL from '../../config/api';
import styles from './BankDetailsForm.module.scss';
import { useAuth } from '../../context/AuthContext.jsx';

const BankDetailsForm = ({ isOpen, onClose, onSuccess }) => {
  const { makeAuthenticatedRequest } = useAuth();
  const [formData, setFormData] = useState({
    office_name: '',
    accountant_name: '',
    official_email: '',
    bank_accounts: [
      { bank_name: '', account_type: '', account_number: '' },
      { bank_name: '', account_type: '', account_number: '' },
      { bank_name: '', account_type: '', account_number: '' },
      { bank_name: '', account_type: '', account_number: '' },
      { bank_name: '', account_type: '', account_number: '' },
      { bank_name: '', account_type: '', account_number: '' }
    ]
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleBankAccountChange = (index, field, value) => {
    setFormData(prev => ({
      ...prev,
      bank_accounts: prev.bank_accounts.map((account, i) => 
        i === index ? { ...account, [field]: value } : account
      )
    }));
  };

  const addNewBankAccount = () => {
    setFormData(prev => ({
      ...prev,
      bank_accounts: [...prev.bank_accounts, { bank_name: '', account_type: '', account_number: '' }]
    }));
  };

  const removeBankAccount = (index) => {
    if (formData.bank_accounts.length > 1) {
      setFormData(prev => ({
        ...prev,
        bank_accounts: prev.bank_accounts.filter((_, i) => i !== index)
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Filter out empty bank accounts
      const validBankAccounts = formData.bank_accounts.filter(
        account => account.bank_name.trim() || account.account_type.trim() || account.account_number.trim()
      );

      if (validBankAccounts.length === 0) {
        setError('कृपया कम्तिमा एउटा बैंक खाताको विवरण भर्नुहोस्।');
        setLoading(false);
        return;
      }

      // Create the group data
      const groupData = {
        office_name: formData.office_name,
        account_head_name: formData.accountant_name,
        official_email: formData.official_email,
        bank_accounts: validBankAccounts,
        created_by: 'User'
      };

      // Use bulk create endpoint to create all bank accounts as one group
      const response = await makeAuthenticatedRequest(`${API_BASE_URL}/api/bank-details/bulk_create_group/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(groupData)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to create bank details');
      }

      onSuccess({
        message: result.message,
        referenceCode: result.reference_code,
        count: result.created_count
      });

      // Reset form
      setFormData({
        office_name: '',
        accountant_name: '',
        official_email: '',
        bank_accounts: [
          { bank_name: '', account_type: '', account_number: '' },
          { bank_name: '', account_type: '', account_number: '' },
          { bank_name: '', account_type: '', account_number: '' },
          { bank_name: '', account_type: '', account_number: '' },
          { bank_name: '', account_type: '', account_number: '' },
          { bank_name: '', account_type: '', account_number: '' }
        ]
      });

      onClose();
    } catch (err) {
      setError(err.message || 'Failed to create bank details');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2>बैंक खाता विवरण फारम</h2>
          <button onClick={onClose} className={styles.closeButton}>
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.tableContainer}>
            <table className={styles.formTable}>
              <tbody>
                <tr>
                  <th colSpan="4" className={styles.centerHeader}>
                    मध्यपश्चिम विश्वविद्यालय
                  </th>
                </tr>
                <tr>
                  <td>कार्यालयको नाम.-</td>
                  <td colSpan="3">
                    <input
                      type="text"
                      value={formData.office_name}
                      onChange={(e) => handleInputChange('office_name', e.target.value)}
                      placeholder="कार्यालयको नाम भर्नुहोस्"
                      required
                    />
                  </td>
                </tr>
                <tr>
                  <td>लेखा प्रमुखको नाम</td>
                  <td colSpan="3">
                    <input
                      type="text"
                      value={formData.accountant_name}
                      onChange={(e) => handleInputChange('accountant_name', e.target.value)}
                      placeholder="लेखा प्रमुखको नाम भर्नुहोस्"
                      required
                    />
                  </td>
                </tr>
                <tr>
                  <td>लेखा प्रमुखको <b>official Mail ID</b></td>
                  <td colSpan="3">
                    <input
                      type="email"
                      value={formData.official_email}
                      onChange={(e) => handleInputChange('official_email', e.target.value)}
                      placeholder="official email भर्नुहोस्"
                      required
                    />
                  </td>
                </tr>
                <tr>
                  <th colSpan="4" className={styles.centerHeader}>
                    कार्यालयको नाममा सञ्चालित सम्पूर्ण बैक खाताको विवरण
                  </th>
                </tr>
                <tr>
                                          <th>क्र.सं.</th>
                        <th>बैंक नाम</th>
                  <th>खाताको प्रकार</th>
                  <th>खाता नं.</th>
                </tr>
                {formData.bank_accounts.map((account, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <input
                        type="text"
                        value={account.bank_name}
                        onChange={(e) => handleBankAccountChange(index, 'bank_name', e.target.value)}
                        placeholder="बैंकको नाम"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={account.account_type}
                        onChange={(e) => handleBankAccountChange(index, 'account_type', e.target.value)}
                        placeholder="खाताको प्रकार"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={account.account_number}
                        onChange={(e) => handleBankAccountChange(index, 'account_number', e.target.value)}
                        placeholder="खाता नंबर"
                      />
                    </td>
                    {formData.bank_accounts.length > 1 && (
                      <td>
                        <button
                          type="button"
                          onClick={() => removeBankAccount(index)}
                          className={styles.removeButton}
                          title="यो पङ्क्ति हटाउनुहोस्"
                        >
                          ×
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
                <tr>
                  <td colSpan="4" className={styles.addRowCell}>
                    <button
                      type="button"
                      onClick={addNewBankAccount}
                      className={styles.addRowButton}
                    >
                      + नयाँ पङ्क्ति थप्नुहोस्
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className={styles.note}>
            <p><b>नोट:-</b> सम्पूर्ण नमस्कार, माथि उल्लेखित विवरण अनिवार्यरुपमा भर्नुहोस् जानकारी गराइन्छ ।</p>
          </div>

          {error && <div className={styles.error}>{error}</div>}

          <div className={styles.formActions}>
            <button
              type="button"
              onClick={onClose}
              className={styles.cancelButton}
              disabled={loading}
            >
              रद्द गर्नुहोस्
            </button>
            <button
              type="submit"
              className={styles.submitButton}
              disabled={loading}
            >
              {loading ? 'सुरक्षित गर्दै...' : 'सुरक्षित गर्नुहोस्'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BankDetailsForm;
